import List from "../../containers/ActivityCategories/List";
import Entry from "../../containers/ActivityCategories";

const testRoutes = [
  {
    path: "/activity-categories",
    exact: true,
    auth: true,
    component: List
  },
  {
    path: "/activity-categories/:type",
    exact: true,
    auth: true,
    component: Entry
  },
  {
    path: "/activity-categories/:type/:id",
    exact: true,
    auth: true,
    component: Entry
  }
];

export default testRoutes;



// WEBPACK FOOTER //
// ./src/routes/modules/activityCategories.jsx